import { ChangeDetectionStrategy, ChangeDetectorRef, Component, computed, CUSTOM_ELEMENTS_SCHEMA, effect, inject, input, signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { fieldTypeRaw, StructureField } from 'src/app/shared/modular-survey/interfaces';
import { LEVEL_OF_SATISFACTION_3, LEVEL_OF_SATISFACTION_5 } from './config/constants';
import { AbstractControl, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseFormField } from 'src/app/shared/form/abstracts';
import { ModularSurveyForm } from 'src/app/shared/modular-survey/services';

@Component({
  selector: 'app-level-satisfaction-field-wrapper',
  standalone: true,
  imports: [
    TranslateModule
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi:true,
      useExisting: LevelSatisfactionFieldWrapperComponent
    },
  ],
  templateUrl: './level-satisfaction-field-wrapper.component.html',
  styleUrls: ['./level-satisfaction-field-wrapper.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LevelSatisfactionFieldWrapperComponent extends BaseFormField<string> {
  // Inputs
  public field = input.required<StructureField>();
  public form = input.required<FormGroup>();
  public formControlName = input.required<string>();
  
  // Service injections
  private _cdr = inject(ChangeDetectorRef);
  private _modularSurveyFormService = inject(ModularSurveyForm);
  
  // Computed properties
  protected satisfactionLevelOptionList = computed(() => {
    return this.field().type === fieldTypeRaw.satisfaction_level_3
      ? LEVEL_OF_SATISFACTION_3
      : LEVEL_OF_SATISFACTION_5;
  });
  protected formControl = computed(() => this.form().get(this.formControlName()));
  
  // Local signal states
  protected showErrorMessage = signal<boolean>(false);
  
  // Effects
  markAllFieldsAsTouched = effect(() => {
    const control = this.formControl();
    this._markFieldsAsTouched(control, this._cdr);
  }, { allowSignalWrites: true });
  
  // Methods
  protected handleSelectOption(value: string): void {    
    this.formControl().setValue(value);
    this.showErrorMessage.set(false);
    this.formControl().markAsTouched();
  }
  
  protected isOptionSelected(value: string): boolean {
    return this.formControl().value === value;
  }
  
  private _markFieldsAsTouched(control: AbstractControl | null, cdr: any): void {
    if (this._modularSurveyFormService.markAllFormFieldsAsTouched()) {
      this._modularSurveyFormService.markFieldAsTouched(control);

      if (this._modularSurveyFormService.isInvalidField(control)) {
        this.showErrorMessage.set(true);
      }
      cdr.detectChanges();
    }
  }
}
